import api from '@services/api';
import { PaginatedResponse } from '../models/common';
import ProjectSubtype, { GetProjectSubTypes, SharingTypes, UpdateSharingTypes } from '../models/projectSubTypes';

/**
 * <p>
 * API endpoints that covers all PROJECT Subtype CRUD calls
 */
export const projectSubtypeApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // SEARCH
    listSubtypes: builder.query<PaginatedResponse<ProjectSubtype>, GetProjectSubTypes>({
      query: (input: GetProjectSubTypes) =>
        `/building/project-subtype/search?page=${input.page}&size=${input.size}&sortKey=${
          input.sortKey
        }&sortDirection=${input.sortDirection}&enabled=${input.enabled}${
          input.searchTerm ? `&searchTerm=${input.searchTerm}` : ''
        }`,
      providesTags: ['listSubtypes'],
    }),
    // LIST SharingTypes
    listAllSubtypes: builder.query<SharingTypes[], void>({
      query: () => ({
        url: `/building/project-subtype/list`,
        method: 'GET',
      }),
      providesTags: ['listSubtypes'],
    }),
    updateSubtypes: builder.mutation<void, { subTypes: UpdateSharingTypes[] }>({
      query: (input) => ({
        url: `/building/project-subtype/update`,
        method: 'PUT',
        body: input,
      }),
      invalidatesTags: ['listSubtypes'],
    }),
  }),
});

export const { useListSubtypesQuery, useListAllSubtypesQuery, useUpdateSubtypesMutation } = projectSubtypeApi;
